import { isArray } from 'lodash';
import { FC } from 'react';
import { FieldErrors } from 'react-hook-form';
export const defaultErrorMsg = 'Please correct issues marked in red';
export const FormErrors: FC<{
  errors: FieldErrors<any>;
}> = ({
  errors
}) => {
  // Flatten any nested errors
  const allErrors = Object.values(errors).flatMap(x => isArray(x) ? x : [x]);
  if (allErrors.length === 1 && String(allErrors[0]!.message).match(/unique/)) {
    return <span className="text-red-500 mr-auto">{String(allErrors[0]!.message)}</span>;
  }
  return allErrors.length > 0 ? <span className="text-red-500 mr-auto" data-sentry-component="FormErrors" data-sentry-source-file="form-errors.tsx">{defaultErrorMsg}</span> : null;
};